'use client'

// Third-party Imports
import { TbAlertCircle } from 'react-icons/tb'
import { Button } from '@repo/ui/components/ui/button'
import Trans from '@repo/i18n/Trans'
import { cn } from '@repo/ui/lib/utils'

// Hook Imports
import { useAuthContext } from './AuthProvider'

export function ImpersonationBanner() {
  // Hooks
  const { isImpersonating, impersonatedUser, stopImpersonation } = useAuthContext()

  return (
    <div
      className={cn(
        'bg-foreground pli-6 plb-3 sticky z-[100] flex items-center justify-between gap-x-6 gap-y-2 text-white transition-[margin,inset-block-start] duration-300 ease-in-out',
        {
          '-mbs-[54px] -block-start-[54px]': !isImpersonating,
          'block-start-0': isImpersonating
        }
      )}
    >
      <div className='flex items-center gap-3 max-sm:justify-center'>
        <TbAlertCircle className='h-5 w-5 shrink-0' />
        <p className='text-sm max-sm:line-clamp-1'>
          <Trans i18nKey='packages-auth:impersonatingUser' />{' '}
          <span className='font-medium underline'>{impersonatedUser?.email}</span>
        </p>
      </div>
      <Button size='sm' variant='solidDestructive' onClick={() => stopImpersonation()}>
        <Trans i18nKey='packages-auth:exitImpersonation' />
      </Button>
    </div>
  )
}
